// extracted by mini-css-extract-plugin
export var footer = "testimonial-module--footer--AvcPu";
export var person = "testimonial-module--person--AZueh";
export var quoteClose = "testimonial-module--quoteClose--jASJt";
export var quoteOpen = "testimonial-module--quoteOpen--BfFsJ";
export var root = "testimonial-module--root--+HOQ7";
export var text = "testimonial-module--text--Vy7o+";